module.exports = {"140824100":"稷峰镇","140824101":"西社镇","140824102":"化峪镇","140824103":"翟店镇","140824104":"清河镇","140824200":"蔡村乡","140824201":"太阳乡","140824400":"稷山县社区","140824401":"稷山县经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140824.json
// module id = 425
// module chunks = 0